import script from "./BarcodeScanner.vue?vue&type=script&setup=true&lang=js"
export * from "./BarcodeScanner.vue?vue&type=script&setup=true&lang=js"

import "./BarcodeScanner.vue?vue&type=style&index=0&id=80949c4a&scoped=true&lang=css"

import exportComponent from "/app/inventory-ui-actions-runner/_work/inventory-ui/inventory-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-80949c4a"]])

export default __exports__